/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>device.model.ts</name>
///
/// <description>
/// A class for device data
/// </description>
///
/// <author>Yaron Habot</author>
/// <created>16 Sep 2016</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// 16Sep16 YH  1.0.0000         First cut
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------
///

export enum DeviceControlActionType {
    Add,
    Edit,
    Remove,
    OK,
    Cancel,
    Yes,
    No
}


// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/models/device-data-models/device-control-action-type.model.ts